<template>
  <div class="d-inline-flex action-buttons-td position-relative">
    <a class="d-md-none d-inline-block action-dots"
       @click="dotsPressed">
      <DotsSvg/>
    </a>
    <div class="action-buttons-div"
         :class="{ expanded: mob_expanded }"
         v-click-outside="clickedOutside">

      <div class="row row-narrow">

        <div class="col col-auto">
          <a class="btn btn-themed gray d-md-inline-flex d-flex align-items-center"
             v-if="canAddMaterial"
             @click="addMaterial">
            <BoxSvg class="svg-gray mr-2"/>
            {{ $t('add_material') }}
          </a>
        </div>

        <div class="col col-auto">
          <a class="btn btn-themed gray d-md-inline-flex d-flex align-items-center"
             @click="print">
            <PrintSvg class="svg-gray mr-2"/>
            {{ $t('print') }}
          </a>
        </div>

        <div class="col col-auto"
             v-if="editable">
          <a class="btn btn-themed gray d-md-inline-flex d-flex align-items-center"
             @click="edit">
            <EditSvg class="svg-gray mr-2"/>
            {{ $t('edit') }}
          </a>
        </div>

        <div class="col col-auto"
             v-if="editable && canCloseDocument && (document.items_with_materials.length || document.warehouse_inventarization_sheets.length)">
          <b-button class="btn btn-themed gray d-md-inline-flex d-flex align-items-center"
                    :disabled="loading"
                    @click="approve">
            <ApproveSvg class="svg-gray mr-2"/>
            {{ $t('approve') }}
          </b-button>
        </div>

        <div class="col col-auto"
             v-if="document.status === 'finished' && canCloseDocument">
          <a class="btn btn-themed gray d-md-inline-flex d-flex align-items-center"
             @click="cancel">
            <ApproveSvg class="svg-gray mr-2"/>
            {{ $t('cancel') }}
          </a>
        </div>

      </div>

    </div>
  </div>
</template>

<script setup>
import PrintSvg from '@/assets/svg-vue/general/print.svg'
import EditSvg from '@/assets/svg-vue/general/pencil.svg'
import ApproveSvg from '@/assets/svg-vue/general/approve.svg'
import DotsSvg from '@/assets/svg-vue/header/vertical_dots.svg'
import BoxSvg from '@/assets/svg-vue/sidebar/box.svg'
import options from "../../../data/warehouse/warehouseoperation"
import { useStore} from "vuex"
import {getCurrentInstance, onBeforeMount, ref, computed, onMounted} from "vue"

const props = defineProps({
  document: {
    type: Object
  }
})

let noty = null
let i18n = null

const store = useStore()

const mob_expanded = ref(false)
const justOpened = ref(false)

const loading = computed(() => store.state.dom.loading)
const rights = computed(() => store.state.auth.rights)
const canCloseDocument = computed(() => rights.value.includes('close_warehouse_documents') && props.document.operation_type !== 'sale')
const canAddMaterial = computed(() => props.document.status !== 'finished')
const editable = computed(() => {
  return props.document.status === 'draft'
      && props.document.operation_type !== 'movement_to'
      && props.document.operation_type !== 'sale'
})


const approve = async () => {
  const res = await store.dispatch('saveDocument')
  if(res.errors) return
  await store.dispatch('approveDocument')
  noty.info(i18n.t('success_message'))
}

const cancel = async () => {
  await store.dispatch('cancelDocument')
  noty.info(i18n.t('success_message'))
}

const print = () => {
  if(window) {
    window.print()
  }
}

const dotsPressed = () => {
  justOpened.value = true
  mob_expanded.value = !mob_expanded.value
  setTimeout(() => {
    justOpened.value = false
  },20)
}

const clickedOutside = () => {
  if(!justOpened.value) {
    mob_expanded.value = false
  }
}

const edit = () => {
  store.commit('setModule', 'warehouse')
  store.commit('setSelectedModel', JSON.parse(JSON.stringify(props.document)))
  store.commit('setShowModal', true)
}

const addMaterial = () => {
  store.commit('setModule', 'warehouse')
  store.commit("setViewModel", 'materialstock')
  store.commit('setSelectedModel', {})
  store.commit('setShowModal', true)
}

onBeforeMount(() => {
  const instance = getCurrentInstance()
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

onMounted(() => {
  if(props.document.status === 'draft') {
    store.commit('setViewModel', options.model)
    store.commit('setEloquentOptions', options)
  }
})
</script>

<style scoped lang="scss">
.btn-themed {
  svg {
    fill: #87939E;
    width: 16px;
    height: 16px;
  }
}
@media screen and (max-width: 768px) {
  .action-buttons-td {
    .action-dots {
      position: relative;
    }
  }
}
</style>
